<template>
    
    <div style="background-color: white;">

<div class="modal fade" id="modalCargando" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div v-if="estadoDeMensage==1" style="text-align:center"><i class="fas fa-spinner fa-spin" style="color:#09BCEC;font-size:3em"></i><br> <p style="font-size:2em" class="text-center mb-0"> Por favor espere mientras procesamos la información.</p></div>
        <div v-if="estadoDeMensage==2" style="text-align:center"><i class="fas fa-exclamation-triangle" style="color: #e10909;font-size:3em"></i><br><p style="font-size:2em" class="text-center mb-0">¡Lo sentimos!</p> <br> <p style="font-size:2em" class="text-center mb-0"> Ha ocurrido un error mientras se procesaba la información.</p><br> <p style="font-size:2em" class="text-center mb-0">{{mensageSistema}}</p></div>
        <div v-if="estadoDeMensage==3" style="text-align:center"><i class="fas fa-check-circle" style="color: #07cf9d;font-size:3em"></i><br><p style="font-size:2em" class="text-center mb-0">¡Felicidades!</p> <br> <p style="font-size:2em" class="text-center mb-0"> Su registro ha sido exitoso, el folio de su solicitud es {{folioDeAspiranteRegistrado}} además se le ha enviado un correo de confirmación a la dirección especificada.</p></div>
    </div>
    <div v-if="estadoDeMensage!=1" class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
      </div>
    </div>
  </div>
</div>

        <div v-if="convocatoriaEncontrada">
        <h1 class="page-title letraDelTitulo enMayusculas col-12">{{FormularioLlenoPorUsuario.NombreConvocatoria}}</h1>
            <div class="container caja-principal" >
    <div class="caja-contenedora-formulario">
        <div class="pestanas">
           
            <button class="btn boton-pestana" :class="(mostrarInformacion)?'btn-success':'btn-secondary' " @click="mostrarInformacion=true">Información </button>
            <button class="btn boton-pestana" :class="(mostrarInformacion)?'btn-secondary':'btn-success' " @click="mostrarInformacion=false" v-if="CamposParaCrearFormulario.find(c => c.IdTipoCampo==6)!= undefined">Documentos </button>
        </div>
        <div v-show="mostrarInformacion">
            <div class="caja-formulario">
                      <h6>Categorías <label class="asterisco-requerido">(*)</label></h6>
                    <select v-model="FormularioLlenoPorUsuario.CategoriaDeLaConvocatoria" :class="'form-control select-estilos campo'" @change="llenarFormulario()">
                    <option selected value="0">Seleccione una opción.</option>
                    <option v-for="(opcion,index) in CategoriasConvocatoria" :value="opcion.IdCategory" :key="index">{{opcion.CategoryName}}</option>
                    </select>
            </div>
            <div class="caja-formulario" >
                      <h6>CURP del aspirante<label class="asterisco-requerido">(*)</label></h6>
                    <input type="text" v-model="FormularioLlenoPorUsuario.CurpAspirante" class="form-control campo" :class="(FormularioLlenoPorUsuario.CurpAspirante.length!=18 && FormularioLlenoPorUsuario.CurpAspirante.length>0)?'campo-error':''" placeholder="Ingrese clave única de registro de población."  maxlength="18" minlength="18"  @keyup="llenarFormulario()"/>
           </div>  
           
        <div class="caja-formulario" >
                      <h6>Nombre del aspirante<label class="asterisco-requerido">(*)</label></h6>
                    <input type="text" v-model="FormularioLlenoPorUsuario.NombreDelAspirante" :class="'form-control campo'"  placeholder="Ingrese el nombre del aspirante."  @keyup="llenarFormulario()"/>
           </div>  

           <div>        
            <div class="caja-formulario" >
                      <h6>Correo aspirante <label class="asterisco-requerido">(*)</label></h6>
                    <input type="text" v-model="FormularioLlenoPorUsuario.CorreoAspirante" class="form-control campo-email" :class="claseCssParaEmail" onpaste="return false" autocomplete="off"  placeholder="INGRESE CORREO ELECTRÓNICO." @keyup="llenarFormulario()" />
        </div>
        <div class="caja-formulario">
                      <h6>Confirma correo aspirante <label class="asterisco-requerido">(*)</label></h6>
                    <input type="text" v-model="correoAspiranteValidado" class='form-control campo campo-email' :class="claseCssParaEmail" onpaste="return false" autocomplete="off" placeholder="CONFIRME SU CORREO ELECTRÓNICO." @keyup="llenarFormulario()" />
        </div>
        </div>

        <div v-for="(TiposDeCamposParaFormulario,index) in CamposParaCrearFormulario" :key="index">

        <div class="caja-formulario" v-if="TiposDeCamposParaFormulario.IdTipoCampo==1">
            <h6>{{TiposDeCamposParaFormulario.Nombrecampo}} <label v-if="TiposDeCamposParaFormulario.Requerido" class="asterisco-requerido">(*)</label></h6>
            <input type="text" :id="TiposDeCamposParaFormulario.FormularioIdentificador" :class="'form-control campo'" placeholder="Ingrese información." @keyup="llenarFormulario()"/>
        </div>

        <div class="caja-formulario" v-if="TiposDeCamposParaFormulario.IdTipoCampo==2">
            <h6>{{TiposDeCamposParaFormulario.Nombrecampo}} <label v-if="TiposDeCamposParaFormulario.Requerido" class="asterisco-requerido">(*)</label></h6>
            <input type="date" :id="TiposDeCamposParaFormulario.FormularioIdentificador" :language="es" :class="'form-control campo'" format="MM-dd-yyyy" :keyup="llenarFormulario()"/>
          </div>  
                
         <div class="caja-formulario" v-if="TiposDeCamposParaFormulario.IdTipoCampo==7">
                      <h6>{{TiposDeCamposParaFormulario.Nombrecampo}}<label v-if="TiposDeCamposParaFormulario.Requerido" class="asterisco-requerido">(*)</label></h6>
                    <input type="text" :id="TiposDeCamposParaFormulario.FormularioIdentificador" :class="'form-control campo'"  placeholder="Ingrese clave única de registro de población." @keyup="llenarFormulario()" maxlength="18"/>
        </div>

        <div class="caja-formulario" v-if="TiposDeCamposParaFormulario.IdTipoCampo==4">
                    <h6>{{TiposDeCamposParaFormulario.Nombrecampo}} <label v-if="TiposDeCamposParaFormulario.Requerido" class="asterisco-requerido">(*)</label></h6>
                    <input type="tel" :id="TiposDeCamposParaFormulario.FormularioIdentificador" :class="'form-control campo'" maxlength="18" placeholder="Ingrese número telefónico." @keyup="llenarFormulario()" @keypress="formateoTelefono(TiposDeCamposParaFormulario.FormularioIdentificador)" @blur="formateoTelefono(TiposDeCamposParaFormulario.FormularioIdentificador)"/>
        </div>
        <div v-if="TiposDeCamposParaFormulario.IdTipoCampo==5">        
            <div class="caja-formulario" >
                      <h6>{{TiposDeCamposParaFormulario.Nombrecampo}} <label v-if="TiposDeCamposParaFormulario.Requerido" class="asterisco-requerido">(*)</label></h6>
                    <input type="text" :id="TiposDeCamposParaFormulario.FormularioIdentificador" class="form-control campo-email" :class="claseCssParaEmail" onpaste="return false" autocomplete="off"  placeholder="INGRESE CORREO ELECTRÓNICO."  @keyup="validarCorreosElectronicos " />
        </div>
        <div class="caja-formulario">
                      <h6>Confirma {{TiposDeCamposParaFormulario.Nombrecampo}} <label v-if="TiposDeCamposParaFormulario.Requerido" class="asterisco-requerido">(*)</label></h6>
                    <input type="text" :id="TiposDeCamposParaFormulario.FormularioIdentificador+'confirma'" class='form-control campo-email date' :class="claseCssParaEmail" onpaste="return false" autocomplete="off" placeholder="CONFIRME SU CORREO ELECTRÓNICO." @keyup="validarCorreosElectronicos" />
        </div>
        </div>
        <div class="caja-formulario" v-if="TiposDeCamposParaFormulario.IdTipoCampo==3">
                      <h6>{{TiposDeCamposParaFormulario.Nombrecampo}} <label v-if="TiposDeCamposParaFormulario.Requerido" class="asterisco-requerido">(*)</label></h6>
                    <select :id="TiposDeCamposParaFormulario.FormularioIdentificador" :class="'form-control select-estilos campo'" @change="llenarFormulario()">
                    <option selected value="">Seleccione una opción.</option>
                    <option v-for="(opcion,i) in TiposDeCamposParaFormulario.opcionesSelectFormularios" :value="opcion.IdOpcionesFormulario" :key="i">{{opcion.NombreSelectOpcion}}</option>
                    <!-- <option value="2">Casado</option> -->
                    </select>
        </div>
        <div class="caja-formulario" v-if="TiposDeCamposParaFormulario.IdTipoCampo==8">
            <h6>{{TiposDeCamposParaFormulario.Nombrecampo}}<label v-if="TiposDeCamposParaFormulario.Requerido" class="asterisco-requerido">(*)</label></h6>
            <textarea type="text" :id="TiposDeCamposParaFormulario.FormularioIdentificador" :class="'form-control campo'" placeholder="Ingrese texto." @keyup="llenarFormulario()"></textarea>        
        </div>

        <div class="caja-formulario" v-if="TiposDeCamposParaFormulario.IdTipoCampo==9">
            <h6>{{TiposDeCamposParaFormulario.Nombrecampo}} <label v-if="TiposDeCamposParaFormulario.Requerido" class="asterisco-requerido">(*)</label></h6>            
            <input type="datetime-local" :id="TiposDeCamposParaFormulario.FormularioIdentificador"  :class="'form-control campo'" :min="new Date().toISOString().slice(0,19)">  
        </div> 
    </div>        
    </div>
<div v-show="mostrarInformacion==false">

<div class="pestanas">
            <h4 style="color: rgb(228, 3, 3)">Solo se aceptarán documentos en formato PDF; además, cada uno de los documentos tendrá que tener un nombre único.</h4>
</div>

<div v-for="(DocumentosPedidosPorElFormulario,index) in CamposParaCrearFormulario" :key="index">
    <div class="caja-formulario" v-if="DocumentosPedidosPorElFormulario.IdTipoCampo==6">
            <h6>{{DocumentosPedidosPorElFormulario.Nombrecampo}}: <label v-if="DocumentosPedidosPorElFormulario.Requerido"  class="asterisco-requerido">(*)</label></h6>
            <input type="file" :id="DocumentosPedidosPorElFormulario.FormularioIdentificador" :class="'form-control select-estilos'" accept=".pdf" @change="cargarDocumento($event,DocumentosPedidosPorElFormulario.FormularioIdentificador)" />
    </div>
</div>

</div>
    </div>
    <div class="botones-guardar">
        <button class="btn btn-danger boton-general"  v-if="mostrarBtnGuardar"   @click="guardarInformacionAspirante()">GUARDAR</button> <!--  v-if="mostrarBtnGuardar" -->
        <button class="btn btn-success boton-general" v-if="!mostrarBtnGuardar"  @click="mostrarInformacion=!mostrarInformacion">CONTINUAR LLENANDO</button>
     
    </div>
</div>
         <!-- MODAL CON VISUALIZADOR DE REPORTE -->
    <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="visualizador-documento">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Reporte generado</h5>
                        <button id="btn-cerrar-visualizador-reporte-notificador-asignaciones" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <PDFDocument 
                            :url="documento.url" 
                            :ArchivoAConvertir=null
                            :EsBase64="EsBase64"
                            :EsBlob = "EsBlob"
                            :height="documento.height"
                            :key="'VACANOT' + documento.contRender" />
                    </div>
                    <button class="btn btn-success" @click="aceptarDocumento">Aceptar</button>           
                </div>
            </div>
        </div>
    </div>

    <div v-if="!convocatoriaEncontrada" class="convocatoria-noencontrada">
        <img class="imagen-nofound" src="https://themisfsweb.poderjudicialags.gob.mx/SICPO/ImagenesPortal/alert.png" alt="Convocatoria no encontrada"><br>
    <label>
        Lo sentimos, la convocatoria no existe o ya ha caducado. 
    </label>
    </div>
</div>

</template>

<script>
import axios from "axios"
import api from '@/../static/js/api'
import Datepicker from 'vuejs-datepicker'
import { es } from 'vuejs-datepicker/dist/locale'
import PDFDocument from '@/../src/components/Comunes/PDFDocument'



export default {
   
    props:{
        seccionDeLaPaginaWeb:Object
    },
    components:{
        Datepicker,
        PDFDocument
    },
    data() {
        return{
        es: es,
        estadoDeMensage:0,
        folioDeAspiranteRegistrado:0,
        mensageSistema:"",
        documento:{
            url:"",
            archivoDeReporte:"",
            height: '750px',
            contRender:1
        },
        EsBase64:false,
        EsBlob : {
            esBlob:true,
            blob:null
        },
        convocatoriaEncontrada:false,
        CamposParaCrearFormulario:[],
        FormularioLlenoPorUsuario:{
            CorreoAspirante:"",
            CurpAspirante:"",
            ConvocatoriaIdentificador:0,
            CategoriaDeLaConvocatoria:0,
            FormularioRegistradoPorAspirante:[],
            NombreConvocatoria:"",
            NombreDelAspirante:"",
            DocumentosCargados:[]
        },
        CategoriasConvocatoria:[],
        mostrarInformacion:true,
        mostrarBtnGuardar:false,
        correoValidado:false,
        claseCssParaEmail:'',
        FormatoFechaHora : 'YYYY-MM-DD HH:MM:SS',
        correoAspiranteValidado:'',
        }
    },       
    methods:{
     

        llenarFormulario:async function(){

             console.log("FORMULARIO LLENO:::",this.FormularioLlenoPorUsuario)
             console.log("llenarFormulario CamposParaAltaFormulario before::",this.CamposParaCrearFormulario);
             console.log("llenarFormulario CamposParaAltaFormulario CategoriaDeLaConvocatoria before::",this.FormularioLlenoPorUsuario.CategoriaDeLaConvocatoria);
             this.CamposParaCrearFormulario.map(e=>{
                 let contenido = e;
                         contenido.valor = $('#'+contenido.FormularioIdentificador).val();        

             });
            console.log("llenarFormulario CamposParaAltaFormulario CategoriaDeLaConvocatoria after ::",this.FormularioLlenoPorUsuario.CategoriaDeLaConvocatoria);
            // console.log("Llenar Formulario Campos Para Alta Formulario ::",this.CamposParaCrearFormulario);
            this.validarFormularioRequerido();
        },
     
          validarFormularioRequerido:function(){ 
    
            let camposRequeridosLLenos = true;

            
    if(this.validarCurp(this.FormularioLlenoPorUsuario.CurpAspirante) && (this.FormularioLlenoPorUsuario.NombreDelAspirante != null && this.FormularioLlenoPorUsuario.NombreDelAspirante !="") && (this.validarCorreoObligatorio()) && (this.FormularioLlenoPorUsuario.CategoriaDeLaConvocatoria > 0) ) {
 
       
         for(let contenido of this.CamposParaCrearFormulario)  {   
 
                console.log("inicio campo:: contenido:",contenido);
        if(contenido.EsRequerido){
            console.log("entra::::")            
            if(contenido.IdTipoCampo==5  ){
                if(!this.correoValidado && (contenido.valor=="" || contenido.valor==null) ){
                camposRequeridosLLenos = false;
                console.log("entra al if type 5:::",contenido.valor);
                break;
            }
             }else if(contenido.IdTipoCampo==7 ){
                if((contenido.valor=="" || contenido.valor==null) && !this.validarCurp(contenido.valor)){
                camposRequeridosLLenos = false;
                console.log("entra al if type 7:::",contenido.valor);
                break;
                   }                
            }else {
                if(contenido.valor=="" || contenido.valor==null || contenido.valor == undefined){
                camposRequeridosLLenos = false;   
                break;  
                  }else{
                        camposRequeridosLLenos = true;
                        console.log("validarFormularioRequerido campos requeridos correctos: " , camposRequeridosLLenos);
                        console.log("validarFormularioRequerido campos requeridos identificador: " , contenido.FormularioIdentificador);
                }
            }            
           }                

        }     
          

           }else{
                 camposRequeridosLLenos = false;
                 console.log("validarFormularioRequerido CamposParaAltaFormulario final::", camposRequeridosLLenos);
                 console.log("validarFormularioRequerido CategoriaDeLaConvocatoria validation::", this.FormularioLlenoPorUsuario.CategoriaDeLaConvocatoria);
                 
            }
           
           console.log("validarFormularioRequerido validando::",camposRequeridosLLenos)
           this.mostrarBtnGuardar = camposRequeridosLLenos;
          },

        guardarInformacionAspirante:async function(){debugger
 

            // let dialog = bootbox.dialog({
            //                     message: '<div style="text-align:center"><i class="fas fa-spinner fa-spin" style="color:#09BCEC;font-size:3em"></i><br> <p style="font-size:2em" class="text-center mb-0"> Por favor espere mientras procesamos la información.</p></div>',
            //                     closeButton: false
            //                     });
            $('#modalCargando').modal('show')
            this.estadoDeMensage = 1;

            const SERVIDOR = api.conexion;             
            const METODO_API_AGREGAR = api.SICPO.sistema.paginaweb.convocatoriasWeb.NuevoAspirante;
            const END_POINT = SERVIDOR+METODO_API_AGREGAR;
             return axios.post(END_POINT, this.crearPeticion()).then(async response => {
                // $('#modalCargando').modal('hide')
                console.log("respuesta:::",response);
               
               
               
                if(response.data.SiHayError){
                    this.mensageSistema = (response.data.Error.MensajeDeSistema=="No se puede crear un archivo que ya existe.\r\n")?"Hay archivos con nombres iguales; favor de cambiar el nombre e intentarlo de nuevo.":response.data.Error.MensajeDeSistema;
              
                    this.estadoDeMensage = 2;
                  //  $('#modalCargando').modal('hide')
                    // let mensaje = (response.data.Error.MensajeDeSistema=="No se puede crear un archivo que ya existe.\r\n")?"Hay archivos con nombres iguales; favor de cambiar el nombre e intentarlo de nuevo.":response.data.Error.MensajeDeSistema;
              
                  
                    // bootbox.dialog({                  
                    //             message: '<div style="text-align:center"><i class="fas fa-exclamation-triangle" style="color: #e10909;font-size:3em"></i><br><p style="font-size:2em" class="text-center mb-0">¡Lo sentimos!</p> <br> <p style="font-size:2em" class="text-center mb-0"> Ha ocurrido un error mientras se procesaba la información.</p><br> <p style="font-size:2em" class="text-center mb-0">'+mensaje+'</p></div>',
                    //             buttons: {
                    //             cancel: {
                    //             label: "Cerrar",
                    //             className: 'btn-danger',
                    //         }
                    //     }
                    // });
                    // //dialog.modal('hide');
                    // for(var i = 0; i<= document.getElementsByClassName('fade').length;i++){
                    // document.getElementsByClassName('fade')[i].remove()
                    // }
                    this.FormularioLlenoPorUsuario.FormularioRegistradoPorAspirante =[];
                }
                else if(response.data.folioDeRegistro==-1){
                    this.mensageSistema = "Ya hay un usuario registrado con esta CURP"
                    this.estadoDeMensage = 2;
                    this.FormularioLlenoPorUsuario.FormularioRegistradoPorAspirante =[];
                    // $('#modalCargando').modal('hide')
                    // let mensaje = "Ya hay un usuario registrado con esta CURP";
                    // bootbox.dialog({                  
                    //             message: '<div style="text-align:center"><i class="fas fa-exclamation-triangle" style="color: #e10909;font-size:3em"></i><br><p style="font-size:2em" class="text-center mb-0">¡Lo sentimos!</p> <br> <p style="font-size:2em" class="text-center mb-0"> Ha ocurrido un error mientras se procesaba la información.</p><br> <p style="font-size:2em" class="text-center mb-0">'+mensaje+'</p></div>',
                    //             buttons: {
                    //             cancel: {
                    //             label: "Cerrar",
                    //             className: 'btn-danger',
                    //         }
                    //     }
                    // });
                }
                else{
                    // $('#modalCargando').modal('hide')
                  
                    // bootbox.dialog({                  
                    //             message: '<div style="text-align:center"><i class="fas fa-check-circle" style="color: #07cf9d;font-size:3em"></i><br><p style="font-size:2em" class="text-center mb-0">¡Felicidades!</p> <br> <p style="font-size:2em" class="text-center mb-0"> Su registro ha sido exitoso, el folio de su solicitud es '+response.data.folioDeRegistro+' además se le ha enviado un correo de confirmación a la dirección especificada.</p></div>',
                    //             buttons: {
                    //             cancel: {
                    //             label: "Entendido",
                    //             className: 'btn-info',
                    //             }
                    //     }
                    // });
                    this.folioDeAspiranteRegistrado=response.data.folioDeRegistro;
                    this.estadoDeMensage = 3;

                    this.limpiarFormulario();
                    
                }
             }).catch(e => {
                this.mensageSistema = e.message;
                this.estadoDeMensage = 2;
               // dialog.modal('hide');
            //    $('#modalCargando').modal('hide')
            //     bootbox.dialog({                  
            //                     message: '<div style="text-align:center"><i class="fas fa-exclamation-triangle" style="color: #e10909;font-size:3em"></i><br><p style="font-size:2em" class="text-center mb-0">¡Lo sentimos!</p> <br> <p style="font-size:2em" class="text-center mb-0"> Ha ocurrido un error mientras se procesaba la información.</p></div>',
            //                     buttons: {
            //                     cancel: {
            //                     label: "Cerrar",
            //                     className: 'btn-danger',
            //                 }
            //             }
            //         });
                    this.FormularioLlenoPorUsuario.FormularioRegistradoPorAspirante =[];
                console.log("A sucedido un error en el sistema::",e.message);
             });

             
        
        },
        crearPeticion:function(){
            var bodyFormData = new FormData();
            this.CamposParaCrearFormulario.forEach(fe => {
                let ObjetoCampoFormulario = [];                
                console.log("crearPeticion build request fe:: ",fe);

                 if(fe.valor !=null && fe.valor !="" && fe.valor !=undefined){
                ObjetoCampoFormulario={
                        FormularioIdentificador:fe.FormularioIdentificador,
                        Valor: fe.IdTipoCampo == 6? fe.valorName : fe.valor,
                        TipoCampo:fe.TipoCampo,
                        Nombrecampo: fe.Nombrecampo,
                        IdTipoCampo : fe.IdTipoCampo,
                        EsRequerido : fe.EsRequerido
                    }
                
                this.FormularioLlenoPorUsuario.FormularioRegistradoPorAspirante.push(ObjetoCampoFormulario);
            }
            });
            this.FormularioLlenoPorUsuario.DocumentosCargados.forEach(documento => {
            bodyFormData.append(documento.LLaveDelDocumento,documento.ObjetoFile)
            })

            console.log("FORMULARIO LLENO:::",this.FormularioLlenoPorUsuario)
            bodyFormData.append('CurpAspirante',this.FormularioLlenoPorUsuario.CurpAspirante.toUpperCase());
            bodyFormData.append('ConvocatoriaIdentificador',this.FormularioLlenoPorUsuario.ConvocatoriaIdentificador);

            bodyFormData.append('FormularioRegistradoPorAspirante',JSON.stringify(this.FormularioLlenoPorUsuario.FormularioRegistradoPorAspirante));

            bodyFormData.append('NombreConvocatoria',this.FormularioLlenoPorUsuario.NombreConvocatoria);
            bodyFormData.append('NombreDelAspirante',this.FormularioLlenoPorUsuario.NombreDelAspirante);           
            bodyFormData.append('CorreoAspirante',this.FormularioLlenoPorUsuario.CorreoAspirante);
            bodyFormData.append('CategoriaAspirante',this.FormularioLlenoPorUsuario.CategoriaDeLaConvocatoria);
        return bodyFormData;
        },
        cargarDocumento:function(e, FormularioIdentificador){
            let DocumentoParaCargar = {
                LLaveDelDocumento:FormularioIdentificador,
                ObjetoFile: e.target.files[0]
            }

            this.CamposParaCrearFormulario.map(cont=>{
                //let contenido = cont;              
                     if(cont.IdTipoCampo == 6 && cont.FormularioIdentificador == FormularioIdentificador){
                        cont.valor = DocumentoParaCargar.ObjetoFile;
                        console.log("cargarDocumento documento valor:: ",cont.valor);  
                    }
                
            });

            if(this.FormularioLlenoPorUsuario.DocumentosCargados.length>0){
             this.FormularioLlenoPorUsuario.DocumentosCargados = this.FormularioLlenoPorUsuario.DocumentosCargados.filter(f => f.LLaveDelDocumento != FormularioIdentificador)
            }
            this.FormularioLlenoPorUsuario.DocumentosCargados.push(DocumentoParaCargar);
            this.convierteDocumentoABlob(e.target.files[0]);  
            this.validarFormularioRequerido();
             
        },
        convierteDocumentoABlob:function(documento){
            documento.arrayBuffer().then((arrayBuffer) => {
            const blob = new Blob([new Uint8Array(arrayBuffer)], {type: documento.type });
            this.EsBlob.blob = blob;
            this.documento.contRender++;
            $('#visualizador-documento').modal('show'); 
            console.log('blob',blob);
            });

        },
        aceptarDocumento:function(){
            $('#visualizador-documento').modal('hide'); 
        },
       validarCorreoObligatorio:function(){
           let flag = false;           
            if(this.FormularioLlenoPorUsuario.CorreoAspirante!=null &&this.FormularioLlenoPorUsuario.CorreoAspirante!=null && this.FormularioLlenoPorUsuario.CorreoAspirante !="" && this.correoAspiranteValidado!="" ){     
                if(this.FormularioLlenoPorUsuario.CorreoAspirante.toLowerCase() == this.correoAspiranteValidado.toLowerCase() && this.FormularioLlenoPorUsuario.CorreoAspirante.includes('@') && this.correoAspiranteValidado.includes('@')){
                    this.claseCssParaEmail = 'correo-valido';
                    flag=true;
                    console.log("validarCorreoObligatorio::correo-valido:: ",flag);
                }else{
                    this.claseCssParaEmail = 'correo-invalido';
                    console.log("validarCorreoObligatorio::correo-invalido:: ",flag);
                }
             } 
           console.log("validarCorreoObligatorio::",flag);
         return flag;
              
        },
        validarCorreosElectronicos:function(){
           //console.log("::start validarCorreosElectronicos::");
           //console.log("::validarCorreosElectronicos this.CamposParaCrearFormulario before::",this.CamposParaCrearFormulario);
           this.correoValidado = false
           this.CamposParaCrearFormulario.filter(s => s.IdTipoCampo==5).map(cont => {
           //console.log("::validarCorreosElectronicos mails::",cont);
            let correo = $('#'+cont.FormularioIdentificador).val();
            let correoConfirma = $('#'+cont.FormularioIdentificador+'confirma').val();
           //console.log("entravalidacionde correos",correo);
           //console.log("entravalidacionde correoConfirma",correoConfirma);
            if(correo!=null && correoConfirma!=null && correo !="" && correoConfirma!="" ){                
                if(correo.toLowerCase() == correoConfirma.toLowerCase() && correo.includes('@') && correoConfirma.includes('@')){
                    this.claseCssParaEmail = 'correo-valido';
                    this.correoValidado=true;
                    console.log('correo-valido');
                }else{
                    this.claseCssParaEmail = 'correo-invalido';
                    console.log('correo-invalido');
                }
             } 

           });
           //console.log("::validarCorreosElectronicos this.CamposParaCrearFormulario finall::",this.CamposParaCrearFormulario);
           this.llenarFormulario();
              
        },

        limpiarFormulario:function(){         
            this.mostrarBtnGuardar=false;
            this.claseCssParaEmail='';
            this.correoValidado=false;
            this.correoAspiranteValidado='';
            this.FormularioLlenoPorUsuario ={
            CorreoAspirante:"",
            CurpAspirante:"",
            ConvocatoriaIdentificador:this.FormularioLlenoPorUsuario.ConvocatoriaIdentificador,
            CategoriaDeLaConvocatoria:0,
            FormularioRegistradoPorAspirante:[],
            NombreConvocatoria:"",
            NombreDelAspirante:"",
            DocumentosCargados:[],
            
        };
            //console.log("limpiarFormulario this.CamposParaCrearFormulario:: ", this.CamposParaCrearFormulario);
            this.CamposParaCrearFormulario.map(cont => {
                if(cont.IdTipoCampo==2){ $('#'+cont.FormularioIdentificador).val(new Date());}
                else{
                    $('#'+cont.FormularioIdentificador).val("");
                }

                if(cont.IdTipoCampo==9) $('#'+cont.FormularioIdentificador).val(new Date());
                else{
                    $('#'+cont.FormularioIdentificador).val("");
                }

                if(cont.IdTipoCampo==5) $('#'+cont.FormularioIdentificador+'confirma').val("");
            })

        },

        CrearFormulario:function(){
            console.log("convocatoria:::",this.$route.query.folio)

            const SERVIDOR = api.conexion;             
            const METODO_API = api.SICPO.sistema.paginaweb.convocatoriasWeb.ObtenerNuevaConvocatoria;
            const END_POINT = `${SERVIDOR}${METODO_API}?idConvocatoria=${this.$route.query.folio}`;

           // console.log("Encabezado::::", this.$route.query);
            // console.log("End_point::::", END_POINT, {"idConvocatoria": this.$route.query.folio});
             return axios.get(END_POINT).then(async response => {
                //console.log("respuesta:::",response.data)
                if(response.data.SiHayError || response.data.FolioConvocatoria == 0){
                    console.log("respuesta con error:::",response.data)
                    this.convocatoriaEncontrada = false;
                                                   
                }else{
                   this.convocatoriaEncontrada = true;

                //    this.CamposParaCrearFormulario = response.data.CamposParaCrearFormulario.Json.map((c,i) => {
                //     let contenido = c
                //     contenido.model = contenido.Nombrecampo.replaceAll(" ","_")+i
                //     return contenido;
                //    }); 
                   this.CamposParaCrearFormulario =response.data.CamposParaCrearFormulario;
                   this.FormularioLlenoPorUsuario.NombreConvocatoria = response.data.NombreConvocatoria;
                   this.FormularioLlenoPorUsuario.ConvocatoriaIdentificador = response.data.FolioConvocatoria;
                   this.obtenerCategorias();
                   //this.IdFormulario = response.data.Idformulario;
                   //console.log("convocatoriaEncontrada:::", this.convocatoriaEncontrada )
                  // console.log("CrearFormulario CamposParaCrearFormulario:::", this.CamposParaCrearFormulario );
                }}).catch(e => {
                console.log("A sucedido un error en el sistema::",e.message);
             });
        


        },
        obtenerCategorias:async function(){
            const SERVIDOR = api.conexion;             
            const METODO_API = api.SICPO.sistema.paginaweb.convocatoriasWeb.ObtenerCategorias;
            const END_POINT = `${SERVIDOR}${METODO_API}?idCall=${this.FormularioLlenoPorUsuario.ConvocatoriaIdentificador}`;
            axios.get(END_POINT).then(async response => {
                if(response.data.SiHayError){
                    console.log("respuesta con error:::",response.data)
                    this.convocatoriaEncontrada = false;                                                
                }else{
                   this.convocatoriaEncontrada = true;
                   this.CategoriasConvocatoria =response.data.Categorys;
                   console.log("obtenerCategorias this.CategoriasConvocatoria:: ",this.CategoriasConvocatoria);
                }}).catch(e => {
                console.log("A sucedido un error en el sistema al obtener las categorias::",e.message);
             });
        },

        formateoTelefono:function(elemento){
            //console.log("inputId:::",elemento);
            let telefono = $('#'+elemento).val();
            if (telefono != "")
            { 
                var numeros = telefono.replace(/\D/g, ''),
                char = {0:'(',3:') ',6:'-'};
                telefono = '';
                    let upto = numeros.length; 
                    if(numeros.length < 10) 
                    { 
                        upto = numeros.length; 
                    }
                    else
                    { 
                        upto = 10; 
                    }
                    for (var i = 0; i < upto; i++) {
                        telefono += (char[i]||'') + numeros[i];
                    }
            }
            
           // console.log("formato telefono::",telefono)
            $('#'+elemento).val(telefono);

        },
        validarCurp: function(curp){
            let campoValido = true;
            console.log("validarcurp start :: ",curp);
        if(curp == undefined || curp == null || curp == "" || curp.toString().trim() == "" || curp.toString().trim().length < 18) { 
            console.log("validarcurp curp lengt:: ",curp.length);
            
            //console.log("validarcurp valido ? validation:: ",campoValido);
            campoValido = false;
        }
        console.log("validar curp valido ?:: ",campoValido)
        return campoValido;
        },
     
        filterForm:function(){
           
           // console.log("filterForm this.CamposParaAltaFormulario", this.CamposParaAltaFormulario);
           // console.log("filterForm this.CamposParaCrearFormulario", this.CamposParaCrearFormulario);
        }
      


    },
    mounted(){
       
        this.CrearFormulario();

    }

}
</script>
<style scoped>
.imagen-nofound{
    width: 30%;
}
.convocatoria-noencontrada{
 width: 100%;
 height: 50%;
 text-align: center;
 color: #c90f08;
 font-size: 3em;
 margin-top: 3em;
 border-radius: 25% 10%;
}
.campo-error{
    border:1px solid #c90f08 !important ;
    
}
    .caja-formulario{
        margin-left: 10em;
        margin-right: 10em;
        margin-bottom: 1.5em !important;
        display: block !important;
        color:black
    }
    .caja-principal{
         /* background-color: red;  */
        padding-left: 10em;
        padding-right: 10em;
        padding-bottom: 5em;

    }
    .caja-contenedora-formulario{
        /* background-color: blue; */
        border-color: black;
        padding-block: 2em;
        padding-bottom: 4em;
        border-radius: 25px;
        box-shadow: 0px 0px 30px rgb(188, 188, 189);
    }
    .campo{
        background-color: #e3e2e7;
    border: none;
    color:  #6c757d;
    text-transform: uppercase;
  

    }
    .campo-email{
        background-color: #e3e2e7;
    border: none;
    color:  #6c757d;
    text-transform: lowercase;
    }
    .campo-email::placeholder{
        text-transform: uppercase;
    }
    textarea.campo{
      height: 8em;
    }
    .asterisco-requerido{
        color: rgb(228, 3, 3);
    }
    .select-estilos{
        background-color: #e3e2e7;
        color: #6c757d;
    }
    .pestanas{
       
        margin-bottom: 4em;
        text-align: center;
        border:solid 1px #ced0d1;
        border-radius: 5px;
        padding: .5em;
        
    }
    .boton-pestana{
        width: 40%;
    }
    .botones-guardar{
        text-align: center;
    }
    .boton-general{
        width: 15em;
    }
    .mensaje-procesando{
        font-size: 5em;
    }
    .correo-valido{
        border:solid 1px #05c484;
    }
    .correo-invalido{
        border:solid 1px #c90f08;
    }

    .page-title {
    background-color: rgb(50,50,50);
    color: #FFF;
    padding: 2vh 20vw;
    text-align: center;
    border-top: solid white 15px;

  }

  @media (max-width: 600px) {
    .page-title{
      font-size: 2em;
    }

    h2{
      font-size: 1.8em;
    }
  }



</style>
<style>
    #fecha-nacimiento-convocatoriaweb{
    color:  #6c757d;
    font-size: 1.5em;
}
</style>


// WEBPACK FOOTER //
// src/components/Convocatoria/NuevaConvocatoriaFormulario.vue